
























































































































import {Component, Vue} from 'vue-property-decorator';
import Page, {EMPTY_PAGE} from "@/dto/taxation/Page";
import {
	ServiceInvoice,
	ServiceInvoiceFilter,
	UpdateInvoicePayload
} from "@/components/payroll/business/services/ServiceDTO";
import ServiceInvoiceOrchestrator from "@/services/ServiceInvoiceOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import InvoiceCreationSlider from "@/components/payroll/business/services/invoice/InvoiceCreationSlider.vue";
import EmbeddedFile from "@/components/common/EmbeddedFile.vue";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import moment from "moment";
import {prettyEnum, subSrtIfNeed} from "../../../../../utils/StringUtils";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import ServiceLogView from "@/components/payroll/business/services/ServiceLogView.vue";
import ServiceInvoiceItem from "@/components/payroll/business/services/ServiceInvoiceItem.vue";
import DraftInvoicePreparer from "@/components/payroll/business/services/invoice/DraftInvoicePreparer.vue";
import PaginationComponent from "@/components/util/PaginationComponent.vue";
import {WorkspaceType} from "@/dto/auth/Workspace";

@Component({
	methods: {prettyEnum, subSrtIfNeed},
	components: {
		PaginationComponent,
		DraftInvoicePreparer,
		ServiceInvoiceItem,
		ServiceLogView, SingleFileHolder, BTPortalCollapse, EmbeddedFile, InvoiceCreationSlider}
})
export default class PayeeInvoiceList extends Vue {

	private invoices: Page<ServiceInvoice> = EMPTY_PAGE

	private createInvoice = false;
	private draftInvoice = false

	private selectedInvoice: ServiceInvoice | null = null;

	private filter = new ServiceInvoiceFilter(
		{
			payeeId: this.$wss.getCurrent.id
		}
	)

	openDraft(inv: ServiceInvoice) {
		this.selectedInvoice = inv
		this.draftInvoice = true
	}

	mounted() {
		Application.startLoading()
		this.loadInvoices()
			.finally(Application.stopLoading)
	}

	findInvoices() {
		Application.startLoading()
		this.loadInvoices()
			.finally(Application.stopLoading)
	}

	loadInvoices() {
		return ServiceInvoiceOrchestrator.getPageByFilter(this.filter).then(
			res => {
				this.invoices = res.data
			},
			err => processError(err, this)
		)
	}

	private formatPeriod(inv: ServiceInvoice) {
		if (inv.startDate && inv.endDate) {
			return moment(inv.startDate).format("MMMM Do") + " - " + moment(inv.endDate).format("MMMM Do")
		} else {
			return "Custom period"
		}
	}

	private resolveStatusColor(inv: ServiceInvoice) {
		switch (inv.status) {
			case "DRAFT": return "#818181"
			case "IN_PROGRESS": return "#007bff"
			case "PAID": return "#28a745"
			case "VOIDED": return "#dc3545"
		}
	}

	private loadPage(page: number) {
		this.filter.page = page - 1
		this.findInvoices()
	}

	private loadNextPage() {
		this.filter.page = this.filter.page + 1
		this.findInvoices()
	}

	private voidInvoice(inv: ServiceInvoice) {
		Application.startLoading()
		ServiceInvoiceOrchestrator.changeStatus(
			new UpdateInvoicePayload(
				{
					serviceInvoiceId: inv.id,
					payeeId: this.$wss.getCurrent.id,
					status: 'VOIDED'
				}
			)
		).then(
			() => {
				this.findInvoices()
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}

	private completeInvoice(inv: ServiceInvoice) {
		Application.startLoading()
		ServiceInvoiceOrchestrator.changeStatus(
			new UpdateInvoicePayload(
				{
					serviceInvoiceId: inv.id,
					payeeId: this.$wss.getCurrent.id,
					status: 'PAID'
				}
			)
		).then(
			() => {
				this.findInvoices()
			},
			err => processError(err, this)
		).finally(() => Application.stopLoading())
	}

}
